import React, {PureComponent} from "react";
import withManagers from "../../HOC/withManagers.jsx";
import Picture from "../Picture/Picture.jsx";

import "./FreelanceAgent.scss"

class FreelanceAgent extends PureComponent {
  constructor(props) {
    super(props);
    this.state= {agent: undefined}
  }
  componentDidUpdate = async () => {
    if(this.props.managers) {
      const agent = this.props.managers.find((manager) => {
        return manager.id === this.props.agentId
      })
      if(agent) {
        this.setState({agent: agent})
      }
    }
  }
  renderAgent(agent) {
    return <div className="freelance-agent box  text-center">
      <Picture
        src={agent?.image ?? null}
        alt={agent.fullname}
        className="picture mx-auto"
        size={100}
      />
      <div className={'freelance-agent-info'}>
        <div><strong>{agent.fullname}</strong></div>
        <div>{agent.tel}</div>
        {this.props.showEmail && agent.email &&
          <div>{agent.email}</div>
        }
      </div>
    </div>
  }

  render () {
    const {agent} = this.state

    if(!agent) { return null}

    return (
      <div className="managers-presentation row justify-content-center ">
        <div key={agent.id} className="d-flex flex-column align-items-center manager-presentation mb-4">
          {agent.linkedin_url ?
            <a href={agent.linkedin_url} target="_blank" rel="noreferrer noopener">
              {this.renderAgent(agent)}
            </a> : this.renderAgent(agent)
          }
        </div>
      </div>)
  }
}

export default withManagers(FreelanceAgent);
